import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

interface LegalPageProps {
  title: string;
  children: React.ReactNode;
}

const LegalPage: React.FC<LegalPageProps> = ({ title, children }) => {
  return (
    <div className="legal-page">
      <div className="legal-inner">
        <header className="legal-header">
          <Link to="/" aria-label="SilverScribe home">
            <img
              src="/Logo Trimmed.png"
              alt="SilverScribe"
              className="legal-logo"
            />
          </Link>
          <Link to="/" className="legal-back">
            ← Back to Home
          </Link>
        </header>
        <h1 className="legal-title">{title}</h1>
        <div className="legal-content">{children}</div>
      </div>
    </div>
  );
};

export default LegalPage;
